
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/suppliers/[id]/reviews",
      function () {
        return require("private-next-pages/marketplace/suppliers/[id]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/suppliers/[id]/reviews"])
      });
    }
  